import { el, setAttr } from 'redom';

import SecondLevelCTA from 'generics/components/second-level-cta';

import './index.scss';

class AdvancedSettingsContainer {

  constructor(configuration) {

    this.displayAdvancedSettings = false;

    this.button = new SecondLevelCTA({
      icon: SecondLevelCTA.icons.LEFT_ARROW,
      label: configuration.label,
      onClick: this.toggleAdvancedSettings.bind(this)
    });

    this.advancedSettingsContainer = el('.advanced-settings-container', [
      configuration.content
    ]);

    this.el = el('.advanced-settings-container-main', [
      el('.advanced-settings-toggle-container', this.button),
      this.advancedSettingsContainer
    ]);

  }

  show() {

    setAttr(this.advancedSettingsContainer, { style: { display: 'block' } });
    this.button.addClass(SecondLevelCTA.icons.DOWN_ARROW);
    this.displayAdvancedSettings = true;

  }

  hide() {

    setAttr(this.advancedSettingsContainer, { style: { display: 'none' } });
    this.button.removeClass(SecondLevelCTA.icons.DOWN_ARROW);
    this.displayAdvancedSettings = false;

  }

  toggleAdvancedSettings() {

    if (this.displayAdvancedSettings === true) {
      this.hide();
    } else {
      this.show();
    }

  }

}

export default AdvancedSettingsContainer;